import { AppEnvironment } from './environment.model';

export const environment: AppEnvironment = {
  production: false,
  name: 'qa',
  backendMode: 'relative',
  chatApiBaseUrl: 'https://chat-api-qa.privatecircle.co',
  paymentsApiBaseUrl: 'https://payments-api-qa.privatecircle.co',
  authUiBaseUrl: 'https://user-auth-api-qa.privatecircle.co',
  withCredentials: true,
  privateCircleBaseUrl: 'https://qa-research-webserver.privatecircle.co',
  networksBaseUrl: 'https://networks-qa.privatecircle.co',
  marketsBaseUrl: 'https://markets-qa.privatecircle.co',
  blogBaseUrl: 'https://blog.privatecircle.co',
};
